import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { Rating, Skeleton } from "@mui/material";
import WishlistButton from "../../../Shared/WishlistButton";
import Checkout from "../../Checkout";
import { useQuery } from "react-query";
import { myReviewsFn } from "../../../Services/UserAccount/MyReviews";
import SearchModal from "../../../Shared/Search";
import ImageViwer from "../../../Shared/ImageViewer";

const MyReviews = () => {
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const { data: myReviews, isLoading } = useQuery(
    ["myReviews"],
    () => myReviewsFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  return (
    <>
      <div className="py-4 px-3 shadow h-16 fixed top-0 z-50 bg-white dark:bg-zinc-900 w-full flex justify-between gap-4">
        <span className="flex gap-5 items-center">
          <ArrowBack onClick={() => navigate(-1)} />
          <p className="text-xl">My Reviews</p>
        </span>
        <span className="flex gap-5 items-center ">
          <SearchModal />
          <WishlistButton /> <Checkout />
        </span>
      </div>
      {myReviews?.data?.rating_review_data?.product_rating_list === [] ? (
        <div className="flex h-[90vh] justify-center text-xl font-bold items-center">
          You haven't posted any reviews yet
        </div>
      ) : (
        <div className="flex flex-col gap-2 bg-zinc-200 dark:bg-zinc-700 min-h-full py-[75px] px-2">
          {isLoading
            ? [1, 2, 3, 4, 5].map(() => {
                return (
                  <div className="flex flex-col gap-2 bg-zinc-200 dark:bg-zinc-600 min-h-full">
                    <div className="flex gap-2 rounded-lg shadow bg-white dark:bg-zinc-900 p-3">
                      <Skeleton className="w-[40%] !scale-100" height={80} />
                      <span className="flex flex-col w-[60%] gap-1">
                        <Skeleton />
                        <Skeleton />
                        <Skeleton className="w-1/2" />
                        <Skeleton className="w-3/4" />
                      </span>
                    </div>
                  </div>
                );
              })
            : myReviews?.data?.rating_review_data?.product_rating_list?.map(
                (review) => {
                  return (
                    <div className="flex gap-5 rounded-lg shadow bg-white dark:bg-zinc-900 p-3">
                      <img
                        src={review.review_img}
                        alt=""
                        className="w-20 h-20 object-cover"
                        onClick={() => {
                          setImage(review.review_img);
                          setOpen(true);
                        }}
                      />
                      <span className="flex flex-col items-start gap-1">
                        <p className="capitalize font-semibold">
                          {review.subject}
                        </p>
                        <p>{review.comment}</p>
                        <Rating
                          readOnly
                          value={Number(review.rate)}
                          size="small"
                          precision={0.5}
                          className="!p-0"
                        />
                        <p>{review.create_at.slice(0, 10)}</p>
                      </span>
                    </div>
                  );
                }
              )}
        </div>
      )}
      <ImageViwer open={open} setOpen={setOpen} src={image} />
    </>
  );
};
export default MyReviews;
